import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {

  transform(value: string, limit: number = 80, ellipsis: boolean = true): unknown {

    if (!value) {
      return ''
    }

    if (value.length <= limit) {
      return value;
    }

    let truncated = value.substring(0, limit);
    if (ellipsis) {
      truncated += '...'
    }

    return truncated;
  }

}
